import { graphql, useStaticQuery } from 'gatsby'

import { MarkdownListQueryType } from '~/types/post.types'

import { postItemMapper, postListMapper } from '~/utils/queryUtils'

export const useLatestPostList = (count = 0) => {
  const queryData = useStaticQuery<MarkdownListQueryType>(graphql`
    {
      allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date, frontmatter___title] }) {
        edges {
          node {
            id
            fields {
              slug
            }
            excerpt(pruneLength: 200, truncate: true)
            timeToRead
            frontmatter {
              title
              date
              summary
              tags
              thumbnail {
                childImageSharp {
                  gatsbyImageData
                }
              }
              status
            }
          }
        }
      }
    }
  `)
  const latestPostList = postListMapper(queryData)
    .filter(post => postItemMapper(post).frontmatter.status !== 'writing')
    .slice(0, count ? count : queryData.allMarkdownRemark.edges.length)

  return { latestPostList }
}

export const useTagPostList = (tags: string[]) => {
  const { latestPostList: postList } = useLatestPostList()
  const tagPostList = postList.filter(({ node: { frontmatter } }) =>
    frontmatter.tags.some(tag => tags.includes(tag)),
  )

  return { tagPostList }
}

export const useRelatedPost = (id: string) => {
  const { latestPostList } = useLatestPostList()
  const currentIndex = latestPostList.findIndex(post => post.node.id === id)

  const prevPost = latestPostList[currentIndex - 1]
  const nextPost = latestPostList[currentIndex + 1]

  return { prevPost, nextPost }
}
